import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgRectComponent } from './svgrect.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgRectComponent],
  exports: [SvgRectComponent]
})
export class SvgrectModule { }
